/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAdminDataQualityFixDatesDto } from '../models/work-admin-data-quality-fix-dates-dto';
import { WorkAdminDataQualityResponseDto } from '../models/work-admin-data-quality-response-dto';

@Injectable({ providedIn: 'root' })
export class WorkAdminDataQualityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminDataQualityControllerGetIssues()` */
  static readonly AdminDataQualityControllerGetIssuesPath = '/v2/admin/data-quality/issues';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDataQualityControllerGetIssues()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDataQualityControllerGetIssues$Response(
    params: {
      limit: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAdminDataQualityResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDataQualityService.AdminDataQualityControllerGetIssuesPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAdminDataQualityResponseDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDataQualityControllerGetIssues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDataQualityControllerGetIssues(
    params: {
      limit: number;
    },
    context?: HttpContext
  ): Observable<WorkAdminDataQualityResponseDto> {
    return this.adminDataQualityControllerGetIssues$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAdminDataQualityResponseDto>): WorkAdminDataQualityResponseDto => r.body)
    );
  }

  /** Path part for operation `adminDataQualityControllerFixProjectInstallationDates()` */
  static readonly AdminDataQualityControllerFixProjectInstallationDatesPath = '/v2/admin/data-quality/fix/project/{id}/installation-dates';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDataQualityControllerFixProjectInstallationDates()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDataQualityControllerFixProjectInstallationDates$Response(
    params: {
      id: number;
      body: WorkAdminDataQualityFixDatesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDataQualityService.AdminDataQualityControllerFixProjectInstallationDatesPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDataQualityControllerFixProjectInstallationDates$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDataQualityControllerFixProjectInstallationDates(
    params: {
      id: number;
      body: WorkAdminDataQualityFixDatesDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.adminDataQualityControllerFixProjectInstallationDates$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminDataQualityControllerFillAllInstallationDatesFromBuild()` */
  static readonly AdminDataQualityControllerFillAllInstallationDatesFromBuildPath = '/v2/admin/data-quality/fix/projects/installation-dates-from-build';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDataQualityControllerFillAllInstallationDatesFromBuild()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDataQualityControllerFillAllInstallationDatesFromBuild$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<number>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDataQualityService.AdminDataQualityControllerFillAllInstallationDatesFromBuildPath, 'patch');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDataQualityControllerFillAllInstallationDatesFromBuild$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDataQualityControllerFillAllInstallationDatesFromBuild(
    params?: {
    },
    context?: HttpContext
  ): Observable<number> {
    return this.adminDataQualityControllerFillAllInstallationDatesFromBuild$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `adminDataQualityControllerFixTaskDates()` */
  static readonly AdminDataQualityControllerFixTaskDatesPath = '/v2/admin/data-quality/fix/task/{id}/dates';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDataQualityControllerFixTaskDates()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDataQualityControllerFixTaskDates$Response(
    params: {
      id: number;
      body: WorkAdminDataQualityFixDatesDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDataQualityService.AdminDataQualityControllerFixTaskDatesPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDataQualityControllerFixTaskDates$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminDataQualityControllerFixTaskDates(
    params: {
      id: number;
      body: WorkAdminDataQualityFixDatesDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.adminDataQualityControllerFixTaskDates$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminDataQualityControllerSyncTaskInstallationDates()` */
  static readonly AdminDataQualityControllerSyncTaskInstallationDatesPath = '/v2/admin/data-quality/fix/task/{id}/sync-installation-dates';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDataQualityControllerSyncTaskInstallationDates()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDataQualityControllerSyncTaskInstallationDates$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDataQualityService.AdminDataQualityControllerSyncTaskInstallationDatesPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDataQualityControllerSyncTaskInstallationDates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDataQualityControllerSyncTaskInstallationDates(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.adminDataQualityControllerSyncTaskInstallationDates$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminDataQualityControllerDeleteOrphanTask()` */
  static readonly AdminDataQualityControllerDeleteOrphanTaskPath = '/v2/admin/data-quality/fix/task/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDataQualityControllerDeleteOrphanTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDataQualityControllerDeleteOrphanTask$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDataQualityService.AdminDataQualityControllerDeleteOrphanTaskPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDataQualityControllerDeleteOrphanTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDataQualityControllerDeleteOrphanTask(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.adminDataQualityControllerDeleteOrphanTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
